import { ShoppingCart, ExternalLink } from 'lucide-react'
import styles from '@styles/ProductPurchase.module.css'
import useFormatPrice from '@hooks/useFormatPrice'
import { useCart } from '@context/CartContext'
import useProduct from '@hooks/useProduct'
import Loading from '@components/Loading'
import PropTypes from 'prop-types'
import { useState } from 'react'

const ProductPurchase = ({ id, onWhatsAppPurchase }) => {
  const [discountApplied, setDiscountApplied] = useState(0)
  const [discountCode, setDiscountCode] = useState('')
  const [quantity, setQuantity] = useState(1)
  const { product, loading } = useProduct(id)
  const formatPrice = useFormatPrice()
  const { addToCart } = useCart()

  const handleQuantityChange = e => {
    const value = Number.parseInt(e.target.value)
    setQuantity(value > 0 ? value : 1)
  }

  const applyDiscount = () => {
    if (discountCode === 'DISCOUNT10') {
      setDiscountApplied(0.1)
    } else if (discountCode === 'DISCOUNT20') {
      setDiscountApplied(0.2)
    } else {
      setDiscountApplied(0)
    }
  }

  const calculateTotal = () => {
    if (!product) return '0'
    const subtotal = product.price * quantity
    const discount = subtotal * discountApplied
    return formatPrice(subtotal - discount)
  }

  const handleAddToCart = () => {
    addToCart({ ...product, quantity })
  }

  if (loading) return <Loading />
  if (!product) return <div className={styles.noProduct}>Producto no encontrado</div>

  if (!product.active) {
    return <div className={styles.productInactive}>Este producto no está disponible actualmente</div>
  }

  return (
    <div className={styles.productPurchase}>
      <div className={styles.productPurchaseFlex}>
        <div className={styles.productImageContainer}>
          <img
            className={styles.productImage}
            src={product.image.url || product.image}
            alt={`${product.brand} ${product.reference}`}
            width={300}
            height={300}
            loading='eager'
          />
        </div>
        <div className={styles.productDetails}>
          <div className={styles.productBrand}>{product.brand}</div>
          <h2 className={styles.productReference}>{product.reference}</h2>
          <p className={styles.productPrice}>Precio: {formatPrice(product.price)}</p>

          <div className={styles.quantityContainer}>
            <label htmlFor='quantity'>Cantidad:</label>
            <input
              type='number'
              id='quantity'
              value={quantity}
              onChange={handleQuantityChange}
              min='1'
              className={styles.quantityInput}
            />
          </div>

          <div className={styles.discountContainer}>
            <label htmlFor='discountCode'>Código de descuento:</label>
            <div className={styles.discountInputContainer}>
              <input
                type='text'
                id='discountCode'
                value={discountCode}
                onChange={(e) => setDiscountCode(e.target.value)}
                className={styles.discountInput}
              />
              <button onClick={applyDiscount}>Aplicar</button>
            </div>
          </div>

          {discountApplied > 0 && (
            <p className={styles.discountApplied}>Descuento aplicado: {discountApplied * 100}%</p>
          )}

          <p className={styles.totalPrice}>Total: {calculateTotal()}</p>

          <div className={styles.buttonContainer}>
            <button className={styles.addToCartButton} onClick={handleAddToCart}>
              <ShoppingCart className={styles.buttonIcon} />
              Agregar al carrito
            </button>
            <button className={styles.buyWhatsappButton} onClick={onWhatsAppPurchase}>
              <ExternalLink className={styles.buttonIcon} />
              Comprar por WhatsApp
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

ProductPurchase.propTypes = {
  id: PropTypes.string.isRequired,
  onWhatsAppPurchase: PropTypes.func.isRequired,
}

export default ProductPurchase
